/* eslint-disable no-magic-numbers */
export default (fromDate) => {
    if (!fromDate) {
        return 0;
    }
    const date1 = new Date();
    const date2 = new Date(fromDate);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};
